import React, { Component } from "react";
import Proptypes from "prop-types";

export default class ViewAzureDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentDnsProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentDnsProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Subscription ID</h4></td><td>{currentDnsProviderConfig.azure_subscription_id}</td></tr>
                <tr><td><h4>Resource Group</h4></td><td>{currentDnsProviderConfig.azure_resource_group}</td></tr>
                <tr><td><h4>Tenant ID</h4></td><td><span>{currentDnsProviderConfig.azure_tenant_id}</span></td></tr>
                <tr><td><h4>Client ID</h4></td><td>{currentDnsProviderConfig.azure_client_id}</td></tr>
                <tr><td><h4>Client Secret</h4></td><td>{currentDnsProviderConfig.azure_client_secret}</td></tr>
                <tr><td><h4>Azure Authority</h4></td><td>{currentDnsProviderConfig.azure_authority}</td></tr>
                <tr><td><h4>Region</h4></td><td>{currentDnsProviderConfig.azure_region}</td></tr>
            </React.Fragment>
        );
    }
}

ViewAzureDnsProviderConfig.propTypes = {
    currentDnsProviderConfig: Proptypes.object.isRequired,
};
